<template>
  <p class="pointer-events-none absolute inset-x-0 bottom-0 px-4 py-8 text-center font-Spectral text-[20px] font-medium capitalize leading-7 tracking-[0.5px] text-white">
    <slot />
  </p>
</template>

<script lang="ts" setup></script>
